module.exports = "/_next/static/images/bf3bb1a1a9c0ffc128578a76ea053f7e-analysis-new.svg";